import { type RouteRecordRaw } from 'vue-router'

import { useApplicationCfgStore } from '../applicationCfg/applicationCfg.store'
import { useFestivalStore } from '../festival/festival.store'
import { useGuestTypeStore } from '../guestTypes/guestType.store'
import { useProgramsStore } from '../programs/programs.store'
import { useStoresInformationsStore } from '../storesInformations/storesInformations.store'
import { useStaticCfgsStore } from './store/staticCfgs.store'
import { useStaticConfigStore } from './store/staticConfig.store'

export const StaticCfgRouter: RouteRecordRaw[] = [
  {
    path: '/staticCfgs',
    component: async () => import('./staticCfgList.vue'),
    async beforeEnter() {
      await useStaticCfgsStore.getState().list()
    },
  },
  {
    path: '/staticCfg/create',
    component: async () => import('./staticCfgSwitch.vue'),
    async beforeEnter() {
      await useApplicationCfgStore.getState().loadApplicationCfg()
      useStaticConfigStore.getState().createStaticConfig()
      await Promise.all([
        useStoresInformationsStore.getState().loadAppStore(),
        useFestivalStore.getState().loadFestival(),
        useProgramsStore.getState().list(),
        useGuestTypeStore.getState().list(),
      ])
    },
  },
  {
    path: '/staticCfg/:id',
    component: async () => import('./staticCfgSwitch.vue'),
    async beforeEnter(to) {
      await Promise.all([
        useStaticConfigStore
          .getState()
          .loadStaticConfig({ oid: to.params.id as string }),
        useStoresInformationsStore.getState().loadAppStore(),
        useFestivalStore.getState().loadFestival(),
        useApplicationCfgStore.getState().loadApplicationCfg(),
        useProgramsStore.getState().list(),
        useGuestTypeStore.getState().list(),
      ])
    },
  },
]
